import { render, staticRenderFns } from "./HistoricalNodes1946.vue?vue&type=template&id=626f0c10&"
import script from "./HistoricalNodes1946.vue?vue&type=script&lang=js&"
export * from "./HistoricalNodes1946.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalNodes1946.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports